// extracted by mini-css-extract-plugin
export var cartIcon = "_mf-0";
export var cartIconContainer = "_mf-1";